import { render, staticRenderFns } from "./Echarts.vue?vue&type=template&id=028b562e&"
import script from "./Echarts.vue?vue&type=script&lang=js&"
export * from "./Echarts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports